import { REDDIT_CLIENT_ID } from './oauth2'

// export const REDDIT_OAUTH = (redirectUri: string): string =>
//   `https://www.reddit.com/api/v1/authorize?client_id=${REDDIT_CLIENT_ID}&response_type=code&redirect_uri=${redirectUri}&duration=permanent&scope=*&state=""`

export const REDDIT_OAUTH = (redirectUri: string): string => {
  const state = Math.random().toString(36).substring(2)
  const scopes = 'identity,read,submit,mysubreddits,vote,history'

  return `https://www.reddit.com/api/v1/authorize?client_id=${REDDIT_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(
    redirectUri
  )}&duration=permanent&scope=${scopes}&state=${state}`
}

export const INSTAGRAM_OAUTH = (
  redirectUri: string,
  appId: string,
  scope: string
): string => {
  return `https://api.instagram.com/oauth/authorize?client_id=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}`
}
